const floatingContainer = new URL('../../icons/floating-container.png', import.meta.url).href

export default {
  type: 'FloatingContainer',
  description: 'floating container',
  icon: floatingContainer,
  group: ['etc'],
  model: {
    type: 'FloatingContainer',
    left: 100,
    top: 100,
    width: 20,
    height: 20,
    strokeStyle: 'black',
    lineWidth: 1,
    fillStyle: 'white'
  }
}
